export default __webpack_public_path__ + "static/media/logo-ocean-decade.9f6d1f23.svg";